import { useEffect, useState } from "react";

import { HOSPITAL_OPEN_KEY } from "../config/params";

export const useHospitalOpenCheck = () => {
  const [isHospitalOpened, setIsHospitalOpened] = useState<boolean| null>(null);
  const hospitalOpenDay = localStorage.getItem(HOSPITAL_OPEN_KEY);

  useEffect(()=>{
    if (hospitalOpenDay && new Date().getTime() <= new Date(hospitalOpenDay).getTime()) {
      setIsHospitalOpened(false);
    } else {
      setIsHospitalOpened(true);
    }
  }, [hospitalOpenDay]);

  return { isHospitalOpened, setIsHospitalOpened };
};
